import { render, staticRenderFns } from "./KiosksFlag.vue?vue&type=template&id=bf04e5cc&"
import script from "./KiosksFlag.vue?vue&type=script&lang=js&"
export * from "./KiosksFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports